/* globals define */

define([], () => { // eslint-disable-line import/no-amd
  const MINIMUM_POPUP_SIZE = 50;
  const MINIMUM_COMPONENT_SIZE = 1;
  const RESIZE_HANDLE_SIZE = 10;
  const COMPONENT_SNAP_TOLERANCE = 5;

  const ACCORDION_TABS = {
    GOALS: 0,
    FORM_TYPE: 1,
    DESIGN: 2,
    SETTINGS: 3,
    VISIBILITY: 4,
    SUCCESS: 5,
    SERVICES: 6,
    EVENT_SOURCE: 7,
  };

  const HEIGHT_COMPONENTS = ['image', 'background', 'button'];
  const TEXT_ALIGN_COMPONENTS = ['text', 'html', 'textField', 'countdown'];
  const MEDIA_COMPONENTS = ['image', 'background'];
  const FONT_COMPONENTS = [
    'text',
    'html',
    'button',
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'countdown',
    'discount',
  ];
  const COLOR_COMPONENTS = [
    'text',
    'html',
    'button',
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'countdown',
    'discount',
  ];
  const BACKGROUND_COLOR_COMPONENTS = [
    'text',
    'html',
    'image',
    'background',
    'button',
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'countdown',
    'discount',
  ];
  const BORDER_COMPONENTS = [
    'text',
    'html',
    'image',
    'background',
    'button',
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'countdown',
    'discount',
  ];
  const BOX_SHADOW_COMPONENTS = [
    'text',
    'html',
    'image',
    'background',
    'button',
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'countdown',
    'discount',
  ];

  const FIELD_COMPONENTS = [
    'textField',
    'checkbox',
    'dropdown',
    'radio',
    'checkboxGroup',
    'hidden',
  ];
  const OPTION_COMPONENTS = ['dropdown', 'radio', 'checkboxGroup'];
  const ACTION_COMPONENTS = ['button', 'image'];
  const COMPONENT_ACTIONS = ['nothing', 'submit', 'close', 'optout', 'redirect', 'content', 'push', 'custom'];
  const FILL_COMPONENTS = ['image', 'background'];
  const COMPONENT_FILL_MODES = ['normal', 'cover', 'tile'];

  const GridRowLayoutPresets = {
    ONE_COLUMN_CENTERED: '1-col-centered',
    ONE_COLUMN_LEFT: '1-col-left',
    ONE_COLUMN_RIGHT: '1-col-right',
    TWO_COLUMN: '2-col',
  };

  return {
    MINIMUM_POPUP_SIZE,
    MINIMUM_COMPONENT_SIZE,
    RESIZE_HANDLE_SIZE,
    COMPONENT_SNAP_TOLERANCE,
    HEIGHT_COMPONENTS,
    TEXT_ALIGN_COMPONENTS,
    MEDIA_COMPONENTS,
    FONT_COMPONENTS,
    COLOR_COMPONENTS,
    BACKGROUND_COLOR_COMPONENTS,
    BORDER_COMPONENTS,
    BOX_SHADOW_COMPONENTS,
    FIELD_COMPONENTS,
    OPTION_COMPONENTS,
    ACTION_COMPONENTS,
    COMPONENT_ACTIONS,
    FILL_COMPONENTS,
    COMPONENT_FILL_MODES,
    ACCORDION_TABS,
    GridRowLayoutPresets,
  };
});
